import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "phoneNumber",
    standalone: false,
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: string | undefined | null) {
        if (!value) {
            return "";
        }

        const phoneRegex =
            /(?:(?:00|\+)?45)\d{8}\b|\+45\s\d{8}\b|\b\d{2}\s\d{2}\s\d{2}\s\d{2}\b|(?:^|[^+])\b\d{8}\b/g;

        return value.replace(phoneRegex, (match) => {
            // remove spaces for the url
            const telLink = match.replace(/\s+/g, "");
            return `<a href="tel:${telLink}">${match}</a>`;
        });
    }
}
